const Cup = ({ height = "40" }) => (
  <svg
    width="41"
    height={height}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="13.5361"
      y="8.46484"
      width="12.668"
      height="11.2604"
      fill="#DFD70A"
    />
    <path
      d="M19.3421 29.989H15.6473C13.8409 29.989 12.363 31.467 12.363 33.2733V33.6839H10.7209C10.0476 33.6839 9.48926 34.2422 9.48926 34.9155C9.48926 35.5887 10.0476 36.1471 10.7209 36.1471H30.4266C31.0999 36.1471 31.6582 35.5887 31.6582 34.9155C31.6582 34.2422 31.0999 33.6839 30.4266 33.6839H28.7845V33.2733C28.7845 31.467 27.3065 29.989 25.5002 29.989H21.8053V26.2285C21.3948 26.2778 20.9843 26.2942 20.5737 26.2942C20.1632 26.2942 19.7527 26.2778 19.3421 26.2285V29.989Z"
      fill="#39E09A"
    />
    <path
      d="M31.215 19.1345C32.2989 18.7239 33.2513 18.0507 34.0067 17.2953C35.5339 15.6039 36.5356 13.584 36.5356 11.2193C36.5356 8.85465 34.68 6.99902 32.3153 6.99902H31.3957C30.3283 4.81497 28.095 3.3042 25.5004 3.3042H15.6475C13.0529 3.3042 10.8196 4.81497 9.75222 6.99902H8.83262C6.46793 6.99902 4.6123 8.85465 4.6123 11.2193C4.6123 13.584 5.61401 15.6039 7.14121 17.2953C7.89659 18.0507 8.84904 18.7239 9.93285 19.1345C11.6407 23.3384 15.746 26.2942 20.5739 26.2942C25.4019 26.2942 29.5072 23.3384 31.215 19.1345ZM25.2376 13.896L24.2195 15.1441C24.0553 15.3247 23.9403 15.686 23.9568 15.9323L24.0553 17.5416C24.121 18.5269 23.4149 19.0359 22.4953 18.6747L21.0009 18.0835C20.771 18.0014 20.3769 18.0014 20.147 18.0835L18.6526 18.6747C17.733 19.0359 17.0269 18.5269 17.0926 17.5416L17.1911 15.9323C17.2076 15.686 17.0926 15.3247 16.9284 15.1441L15.9103 13.896C15.2698 13.1406 15.549 12.3031 16.5014 12.0568L18.0615 11.6627C18.3078 11.597 18.6034 11.3671 18.7347 11.1536L19.6051 9.80709C20.147 8.9696 21.0009 8.9696 21.5428 9.80709L22.4131 11.1536C22.5445 11.3671 22.8401 11.597 23.0864 11.6627L24.6465 12.0568C25.5989 12.3031 25.8781 13.1406 25.2376 13.896Z"
      fill="#39E09A"
    />
  </svg>
);

export default Cup;
